import {
  calculate as calculateProductOptions,
  CalculateProductOptionsPriceAdditionParams,
} from '@calculations/price/utilities/product-options';
import {
  type SnapRoundingOptions,
  snapRoundPerUnit,
} from '@calculations/round/decimal';
import {} from '@calculations/round/decimal';
import type { VisualMarketPrice } from '@snap-types/models/visual/market-price';
import { Decimal } from '@snap-types/types/decimal';

import {
  calculate as calculateFixedMarket,
  FixedMarketCalculateParams,
} from '../fixed-market/calculate';

export type RAFPartOptionsCalculateParams = FixedMarketCalculateParams &
  CalculateProductOptionsPriceAdditionParams;

export type RAFPartOptionsCalculateResult = {
  quantity: Decimal;
  marketCode: string;
  unitPrice: Decimal;
  marketPrice: VisualMarketPrice;
  unitPriceAddition: Decimal;
  changesUnitPrice: boolean;
};

export function calculate(
  {
    quantity,
    allowFallback,
    marketCode,
    marketPrices,
    productOptions,
    craftProductOptions,
  }: RAFPartOptionsCalculateParams,
  roundingOptions: SnapRoundingOptions,
): RAFPartOptionsCalculateResult | null {
  const fixedMarketResult = calculateFixedMarket(
    {
      quantity,
      allowFallback,
      marketCode,
      marketPrices,
    },
    roundingOptions,
  );

  if (!fixedMarketResult) {
    // @TODO(#2018): Return contextual error
    return null;
  }

  const productOptionsResult = calculateProductOptions({
    quantity,
    productOptions,
    craftProductOptions,
  });

  if (!productOptionsResult.isSuccess) {
    // @TODO(#2018): Return contextual error
    return null;
  }

  const unitPrice = snapRoundPerUnit(
    fixedMarketResult.unitPrice.plus(productOptionsResult.unitPriceAddition),
    roundingOptions,
  );

  return {
    quantity,
    marketCode,
    unitPrice,
    marketPrice: fixedMarketResult.marketPrice,
    unitPriceAddition: productOptionsResult.unitPriceAddition,
    changesUnitPrice: productOptionsResult.changesUnitPrice,
  };
}
